import * as Yup from 'yup';
import { orderDetailSchema } from '../order-detail/validation';

export const orderSchema = Yup.object().shape({
  table: Yup.string().required('Table is required'),
  vendor: Yup.string().required('Vendor is required'),
  items: orderDetailSchema.fields.items,
});

export const orderSchemaOptional = Yup.object().shape({
  table: Yup.string().required('Table is required'),
  vendor: Yup.string().optional(),
  items: orderDetailSchema.fields.items,
});
export const orderSimpleSchemaOptional = Yup.object().shape({
  table: Yup.string().required('Table is required'),
  vendor: Yup.string().required('Vendor is required'),
});
